import React, { useEffect, useState } from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
  CustomInput,
  CustomTimePiker,
  TableHeader,
  TableLoading,
  TableNullData,
  Pagination,
  CustomRadioButtonGroup,
  CustomIcon,
} from "../../../../components";

import "./index.scss";
import { useTranslation } from "react-i18next";
import api from "../../../../api";
import { useQuery } from "react-query";
import convertNumberToPrice from "../../../../utils/convertNumberToPrice";
import utils from "../../../../utils";
import values from "../../../../values";
import convertGregorianToJalali from "../../../../utils/convertGregorianToJalali";
import CustomDropDownSearch from "../../../../components/CustomDropDownMultiSearch";
import {
  DRIVER_OFFLINE_PAYER_TYPE,
  MONTH,
  OFFLINE_PAYER_WAY,
  SETTELMENT_FILTER,
} from "../../../../values/dropdownItems";
import moment from "jalali-moment";
import { IItem } from "../../../../types/common.interface";
import Detail from "./components/Detail";
import firstAndEndOfMonth from "../../../../utils/firstAndEndOfMonth";

const ClosedFactorModal = () => {
  const { showModal, setShowModal, selectedDriver } = React.useContext(
    Context.DriverScreen
  );

  const [selectedStartAt, setSelectedStartAt] = useState<string>();
  const [selectedEndAt, setSelectedEndAt] = useState<string>();
  const [requestClosedFactor, setRequestClosedFactor] = useState({
    driverId: selectedDriver?._id,
    startAt: selectedStartAt,
    endAt: selectedEndAt,
    page: 1,
    limit: 10,
  });

  const [selectedYear, setSelectedYear] = React.useState(SETTELMENT_FILTER[0]);
  const [selected, setSelected] = useState<any>();
  const [selectedMonth, setSelectedMonth] = React.useState<IItem>(
    MONTH.find(
      (item) => item._id === moment().locale("fa").format("jM")
    ) as IItem
  );

  const closedFactor = useQuery(
    ["driverClosedFactor", selectedDriver, selectedYear.name, selectedMonth?._id],
    () =>
      api.post.common.findDriverClosedFactor({
        ...requestClosedFactor,
        driverId: selectedDriver?._id,
        startAt: (selectedYear.name &&
          selectedMonth?._id &&
          firstAndEndOfMonth(selectedYear.name, selectedMonth?._id as string)
            .firstDay) as string,
        endAt: (selectedYear.name &&
          selectedMonth?._id &&
          firstAndEndOfMonth(selectedYear.name, selectedMonth?._id as string)
            .lastDay) as string,

      }),
    { enabled: showModal === "CLOSED_FACTOR" }
  );
  const closedFactorResult = closedFactor?.data?.result?.docs;

  const { t } = useTranslation();

  // console.log(selectedDriver);

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={
          showModal === "CLOSED_FACTOR" ||
          showModal === "DRIVER_TRANSACTION_MODAL"
        }
        label="فاکتورهای بسته شده"
        minHeight={"50rem"}
        maxHeight={"80vh"}
        minWidth={"80vw"}
        maxWidth={"55rem"}
      >
        <div className="closed-factor-container">
          <CustomView.Container className="">
            <CustomView.Row className="user-information-container">
              <CustomView.Column>
                <UserInformation
                  name={selectedDriver?.firstName}
                  avatar={selectedDriver?.avatar}
                  isBlock={
                    !selectedDriver?.driverInformation?.approved?.isApproved
                  }
                  lastName={selectedDriver?.lastName}
                  phoneNumber={selectedDriver?.phoneNumber}
                />
              </CustomView.Column>
            </CustomView.Row>
            <CustomView.Row className="user-information-container">
              <CustomView.Column>
                <CustomDropDownSearch
                  label="سال"
                  items={SETTELMENT_FILTER}
                  baseSearch={[]}
                  itemName="name"
                  onSelectItem={() => {}}
                  placeHolder={""}
                  defaultItem={selectedYear}
                  setSearchedValue={function (event: any): void {}}
                  searchedValue={undefined}
                />
              </CustomView.Column>
              <CustomView.Column className="">
                <CustomDropDownSearch
                  label="ماه"
                  items={MONTH}
                  baseSearch={[]}
                  itemName="name"
                  defaultItem={selectedMonth}
                  onSelectItem={(event) => {
                    setSelectedMonth(event);
                  }}
                  placeHolder={"انتخاب ماه"}
                  setSearchedValue={function (event: any): void {}}
                  searchedValue={undefined}
                />
              </CustomView.Column>
            </CustomView.Row>

            <div className="table-content-wrapper">
              <table className="dropdown">
                <TableHeader headers={values.tableHeaders.DRIVER_TRANSACTION} />
                {closedFactor.status === "loading" ? (
                  <TableLoading />
                ) : (
                  <>
                    {(closedFactor?.data?.result <= 0 ||
                      !closedFactor?.data?.result) && (
                      <TableNullData
                        text={t("driver_has_not_active_service")}
                      />
                    )}

                    <tbody id="driver-table-body-container">
                      {closedFactor?.data?.result?.docs?.map(
                        (factor: any, index: number) => {
                          return (
                            <tr
                              key={`files-tr-${index}`}
                              // onClick={() => onClickRow(factor?.factorId?._id)}
                            >
                              <td>
                                <div className="table-index-number">
                                  {requestClosedFactor.page === 1
                                    ? index + 1
                                    : (requestClosedFactor.page - 1) * 10 +
                                      index +
                                      1}
                                </div>
                              </td>
                              <td>
                                <UserInformation
                                  //avatar={transaction?.driver?.avatar}
                                  name={
                                    factor?.driver?.firstName +
                                    " " +
                                    factor?.driver?.lastName
                                  }
                                  //lastName={transaction?.payerType}
                                  phoneNumber={factor?.driver?.phoneNumber}
                                  hideAvatar
                                />
                              </td>
                              <td>
                                {convertNumberToPrice(factor?.totalAmount)}{" "}
                                {"تومان"}
                              </td>
                              <td>
                                {convertNumberToPrice(factor?.paidAmount)}{" "}
                                {"تومان"}
                              </td>
                              <td>
                                {factor?.isPaid2Driver && "پرداخت به راننده"}
                                {factor?.isPaid4Driver && "دریافت از راننده"}
                              </td>
                              <td>
                                {convertNumberToPrice(
                                  factor?.shares.admin + factor?.shares.company
                                )}{" "}
                                {"تومان"}
                              </td>
                              <td>
                                {convertNumberToPrice(factor?.shares.admin)}{" "}
                                {"تومان"}
                              </td>
                              <td>{factor?.countFactors}</td>
                              <td>
                                {convertGregorianToJalali({
                                  date: factor?.createdAt,
                                  format: "hh:mm  jYYYY/jMM/jDD",
                                })}
                              </td>
                              <td>
                                <CustomIcon
                                  hoverTitle={t("detail")}
                                  icon="fas fa-list"
                                  onClick={() => {
                                    setShowModal!("DRIVER_TRANSACTION_MODAL");
                                    setSelected(factor);
                                  }}
                                />
                              </td>
                              {/* <td className="table-text">
                              {factor?.isOnline ? "آنلاین" : "آفلاین"}
                            </td> */}
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </>
                )}
              </table>
            </div>
          </CustomView.Container>
          {closedFactor.status === "success" &&
            closedFactor?.data?.result?.totalDocs >
              values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
              <div className="pagination">
                <Pagination
                  page={requestClosedFactor?.page}
                  totalPages={closedFactor?.data?.result?.totalPages}
                  onPaginate={(page: number) =>
                    setRequestClosedFactor!({ ...requestClosedFactor, page })
                  }
                />
              </div>
            )}
        </div>
      </CustomModal>
      <Detail selected={selected} />
    </section>
  );
};

export default ClosedFactorModal;
